import script from "./MallTrackingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallTrackingPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallTrackingPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__